<!-- src/components/modal/leads-modal.vue -->
<template>
  <!-- Add/Edit Leads Modal (DEALS-STYLE UPGRADED UI + DROPDOWNS) -->
  <div class="modal fade dq-leads-modal" id="add_leads" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-xl dq-leads-dialog">
      <div class="modal-content dq-modal-content" :key="keyForce">
        <!-- Header -->
        <div class="modal-header dq-modal-header">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-indigo">
              <i class="ti ti-target-arrow"></i>
            </div>

            <div class="dq-headtext">
              <h4 class="modal-title dq-title mb-0">
                {{ isEdit ? "Edit Lead" : "Add New Lead" }}
              </h4>
              <div class="dq-subtitle">
                Capture lead details, pipeline stage, ownership and visibility.
              </div>
            </div>
          </div>

          <div class="dq-head-actions">
            <span class="dq-pill">
              <i class="ti ti-building"></i>
              <span class="dq-pill-label">Type</span>
              <span class="dq-pill-value">{{ form.party_type || "Organization" }}</span>
            </span>

            <button
              type="button"
              class="btn-close custom-btn-close dq-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>

        <form @submit.prevent="submit">
          <!-- Body -->
          <div class="modal-body dq-modal-body">
            <div class="row g-3">

              <!-- Lead Summary -->
              <div class="col-12">
                <div class="dq-card">
                  <div class="dq-card-head">
                    <div class="dq-card-title">
                      <i class="ti ti-sparkles"></i>
                      Lead Summary
                    </div>
                    <div class="dq-card-sub">
                      Required: Lead Name. Optional: Company, Value & Contact details.
                    </div>
                  </div>

                  <div class="row g-3 mt-0">
                    <!-- Lead Name -->
                    <div class="col-12">
                      <label class="form-label dq-label">
                        Lead Name <span class="text-danger">*</span>
                      </label>
                      <input
                        v-model.trim="form.name"
                        type="text"
                        class="form-control dq-input"
                        placeholder="e.g. Acme Ltd — Payroll Inquiry"
                        required
                      />
                    </div>

                    <!-- Person vs Organization -->
                    <div class="col-12">
                      <label class="form-label dq-label">Lead Type</label>

                      <div class="dq-toggle">
                        <label class="dq-pillbtn" :class="form.party_type === 'Person' ? 'active' : ''">
                          <input
                            class="form-check-input"
                            type="radio"
                            value="Person"
                            v-model="form.party_type"
                          />
                          <i class="ti ti-user"></i> Person
                        </label>

                        <label class="dq-pillbtn" :class="form.party_type === 'Organization' ? 'active' : ''">
                          <input
                            class="form-check-input"
                            type="radio"
                            value="Organization"
                            v-model="form.party_type"
                          />
                          <i class="ti ti-building"></i> Organization
                        </label>
                      </div>
                    </div>

                    <!-- Company / Value / Currency -->
                    <div class="col-md-6">
                      <label class="form-label dq-label">Company</label>
                      <input
                        v-model.trim="form.company_name"
                        type="text"
                        class="form-control dq-input"
                        placeholder="e.g. Example Technologies"
                      />
                    </div>

                    <div class="col-md-3">
                      <label class="form-label dq-label">Value</label>
                      <div class="dq-inputgroup">
                        <span class="dq-addon"><i class="ti ti-currency-dollar"></i></span>
                        <input
                          v-model.number="form.amount"
                          type="number"
                          min="0"
                          step="0.01"
                          class="form-control dq-input dq-inputgroup-input"
                          placeholder="0.00"
                        />
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label class="form-label dq-label">Currency</label>
                      <select v-model="form.currency" class="form-select dq-input">
                        <option value="KES">KES</option>
                        <option value="UGX">UGX</option>
                        <option value="TZS">TZS</option>
                        <option value="USD">USD</option>
                        <option value="EUR">EUR</option>
                        <option value="GBP">GBP</option>
                      </select>
                    </div>

                    <!-- Phone + Label -->
                    <div class="col-lg-8">
                      <label class="form-label dq-label">Phone</label>
                      <input
                        v-model.trim="form.phone"
                        class="form-control dq-input"
                        type="text"
                        placeholder="+2547..."
                      />
                    </div>

                    <div class="col-lg-4">
                      <label class="form-label dq-label">Phone Label</label>
                      <select v-model="form.phone_label" class="form-select dq-input">
                        <option value="">Select</option>
                        <option>Work</option>
                        <option>Home</option>
                      </select>
                    </div>

                    <!-- Email + Label -->
                    <div class="col-lg-8">
                      <label class="form-label dq-label">Email</label>
                      <input
                        v-model.trim="form.email"
                        class="form-control dq-input"
                        type="email"
                        placeholder="lead@company.com"
                      />
                    </div>

                    <div class="col-lg-4">
                      <label class="form-label dq-label">Email Label</label>
                      <select v-model="form.email_label" class="form-select dq-input">
                        <option value="">Select</option>
                        <option>Work</option>
                        <option>Home</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Pipeline & Stage -->
              <div class="col-lg-6">
                <div class="dq-card">
                  <div class="dq-card-head">
                    <div class="dq-card-title">
                      <i class="ti ti-route"></i>
                      Pipeline & Stage
                    </div>
                    <div class="dq-card-sub">
                      Place this lead into a pipeline and stage.
                    </div>
                  </div>

                  <div class="row g-3 mt-0">
                    <!-- Pipeline (search dropdown) -->
                    <div class="col-md-6">
                      <label class="form-label dq-label">Pipeline</label>

                      <div class="mb-2">
                        <span v-if="form.pipeline_id" class="badge bg-light text-dark">
                          {{ getPipelineLabel(form.pipeline_id) }}
                          <i class="ti ti-x ms-1" role="button" @click="clearPipeline"></i>
                        </span>
                        <span v-else class="text-muted">No pipeline selected</span>
                      </div>

                      <div class="dropdown w-100" data-bs-auto-close="outside" data-bs-display="static">
                        <button
                          class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center"
                          type="button"
                          data-bs-toggle="dropdown"
                          @click="openPipelineDropdown"
                        >
                          <span class="text-truncate">
                            {{ form.pipeline_id ? "Change pipeline…" : "Search pipeline…" }}
                          </span>
                          <i class="ti ti-chevron-down ms-2"></i>
                        </button>

                        <div class="dropdown-menu p-2 w-100 shadow">
                          <input
                            v-model="pipelineQuery"
                            @input="onPipelineInput"
                            type="text"
                            class="form-control mb-2"
                            placeholder="Search pipelines…"
                            autocomplete="off"
                          />

                          <div class="search-list">
                            <div v-if="pipelineLoading" class="text-center py-2 small text-muted">
                              Loading…
                            </div>

                            <button
                              v-for="opt in pipelineOptions"
                              :key="'pipe-' + opt.id"
                              type="button"
                              class="dropdown-item d-flex justify-content-between align-items-center"
                              @click="selectPipeline(opt)"
                            >
                              <span class="text-truncate">{{ opt.label }}</span>
                              <i class="ti" :class="form.pipeline_id === opt.id ? 'ti-check' : 'ti-forms'"></i>
                            </button>

                            <div v-if="!pipelineLoading && !pipelineOptions.length" class="text-center py-2 small text-muted">
                              No results
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="dq-help" v-if="!form.pipeline_id">
                        Pick a pipeline to load its stages.
                      </div>
                    </div>

                    <!-- Stage (search dropdown) -->
                    <div class="col-md-6">
                      <label class="form-label dq-label">Stage</label>

                      <div class="mb-2">
                        <span v-if="form.stage_id" class="badge bg-light text-dark">
                          {{ getStageLabel(form.stage_id) }}
                          <i class="ti ti-x ms-1" role="button" @click="form.stage_id = null"></i>
                        </span>
                        <span v-else class="text-muted">No stage selected</span>
                      </div>

                      <div class="dropdown w-100" data-bs-auto-close="outside" data-bs-display="static">
                        <button
                          class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center"
                          type="button"
                          data-bs-toggle="dropdown"
                          :disabled="!form.pipeline_id"
                          @click="openStageDropdown"
                        >
                          <span class="text-truncate">
                            {{ form.pipeline_id ? "Search stage…" : "Select pipeline first" }}
                          </span>
                          <i class="ti ti-chevron-down ms-2"></i>
                        </button>

                        <div class="dropdown-menu p-2 w-100 shadow">
                          <input
                            v-model="stageQuery"
                            @input="onStageInput"
                            type="text"
                            class="form-control mb-2"
                            placeholder="Search stages…"
                            autocomplete="off"
                            :disabled="!form.pipeline_id"
                          />

                          <div class="search-list">
                            <div v-if="stageLoading" class="text-center py-2 small text-muted">
                              Loading…
                            </div>

                            <button
                              v-for="opt in stageDropdownOptions"
                              :key="'stage-' + opt.id"
                              type="button"
                              class="dropdown-item d-flex justify-content-between align-items-center"
                              @click="selectStage(opt)"
                            >
                              <span class="text-truncate">{{ opt.label }}</span>
                              <i class="ti" :class="form.stage_id === opt.id ? 'ti-check' : 'ti-git-branch'"></i>
                            </button>

                            <div v-if="!stageLoading && !stageDropdownOptions.length" class="text-center py-2 small text-muted">
                              No results
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="dq-help" v-if="form.pipeline_id && !stageOptions.length">
                        No stages found for this pipeline.
                      </div>
                    </div>

                    <!-- Source / Industry -->
                    <div class="col-md-6">
                      <label class="form-label dq-label">Source</label>
                      <input
                        v-model.trim="form.source"
                        class="form-control dq-input"
                        placeholder="Phone, Social Media, Referral..."
                      />
                    </div>

                    <div class="col-md-6">
                      <label class="form-label dq-label">Industry</label>
                      <input
                        v-model.trim="form.industry"
                        class="form-control dq-input"
                        placeholder="e.g. Logistics, Retail…"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Ownership & Tags -->
              <div class="col-lg-6">
                <div class="dq-card">
                  <div class="dq-card-head">
                    <div class="dq-card-title">
                      <i class="ti ti-user-check"></i>
                      Ownership & Tags
                    </div>
                    <div class="dq-card-sub">
                      Assign owner and tag for follow-ups.
                    </div>
                  </div>

                  <div class="row g-3 mt-0">
                    <!-- Owner (search dropdown) -->
                    <div class="col-12">
                      <label class="form-label dq-label">Owner</label>

                      <div class="mb-2">
                        <span v-if="form.owner_id" class="badge bg-light text-dark">
                          {{ getOwnerLabel(form.owner_id) }}
                          <i class="ti ti-x ms-1" role="button" @click="form.owner_id = null"></i>
                        </span>
                        <span v-else class="text-muted">No owner selected</span>
                      </div>

                      <div class="dropdown w-100" data-bs-auto-close="outside" data-bs-display="static">
                        <button
                          class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center"
                          type="button"
                          data-bs-toggle="dropdown"
                          @click="openOwnerDropdown"
                        >
                          <span class="text-truncate">
                            {{ form.owner_id ? "Change owner…" : "Search owner…" }}
                          </span>
                          <i class="ti ti-chevron-down ms-2"></i>
                        </button>

                        <div class="dropdown-menu p-2 w-100 shadow">
                          <input
                            v-model="ownerQuery"
                            @input="onOwnerInput"
                            type="text"
                            class="form-control mb-2"
                            placeholder="Search users…"
                            autocomplete="off"
                          />

                          <div class="search-list">
                            <div v-if="ownerLoading" class="text-center py-2 small text-muted">
                              Loading…
                            </div>

                            <button
                              v-for="opt in ownerOptions"
                              :key="'owner-' + opt.id"
                              type="button"
                              class="dropdown-item d-flex justify-content-between align-items-center"
                              @click="selectOwner(opt)"
                            >
                              <span class="text-truncate">{{ opt.label }}</span>
                              <i class="ti" :class="form.owner_id === opt.id ? 'ti-check' : 'ti-user'"></i>
                            </button>

                            <div v-if="!ownerLoading && !ownerOptions.length" class="text-center py-2 small text-muted">
                              No results
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Tags (Deals-style pills) -->
                    <div class="col-12">
                      <label class="form-label dq-label d-block">Tags</label>
                      <div class="dq-tags">
                        <label class="dq-tagcheck">
                          <input class="form-check-input" type="checkbox" value="Closed" v-model="form.tags" />
                          <span>Closed</span>
                        </label>
                        <label class="dq-tagcheck">
                          <input class="form-check-input" type="checkbox" value="Contacted" v-model="form.tags" />
                          <span>Contacted</span>
                        </label>
                        <label class="dq-tagcheck">
                          <input class="form-check-input" type="checkbox" value="Lost" v-model="form.tags" />
                          <span>Lost</span>
                        </label>
                        <label class="dq-tagcheck">
                          <input class="form-check-input" type="checkbox" value="Not Contacted" v-model="form.tags" />
                          <span>Not Contacted</span>
                        </label>
                      </div>

                      <div v-if="form.tags?.length" class="dq-selected-tags">
                        <span class="dq-mini">Selected:</span>
                        <span v-for="t in form.tags" :key="t" class="dq-chip">
                          <i class="ti ti-tag"></i> {{ t }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Notes -->
              <div class="col-12">
                <div class="dq-card">
                  <div class="dq-card-head">
                    <div class="dq-card-title">
                      <i class="ti ti-notes"></i>
                      Notes
                    </div>
                    <div class="dq-card-sub">Add context for the team.</div>
                  </div>

                  <div class="mt-2">
                    <label class="form-label dq-label">Description</label>
                    <textarea
                      v-model.trim="form.description"
                      class="form-control dq-input dq-textarea"
                      rows="4"
                      placeholder="Write a short note about this lead..."
                    ></textarea>
                  </div>
                </div>
              </div>

              <!-- Visibility (Deals-style cards + searchable people picker) -->
              <div class="col-12">
                <div class="dq-card">
                  <div class="dq-card-head">
                    <div class="dq-card-title">
                      <i class="ti ti-eye"></i>
                      Visibility
                    </div>
                    <div class="dq-card-sub">
                      Control who can view this lead.
                    </div>
                  </div>

                  <div class="dq-visibility">
                    <label class="dq-radio">
                      <input class="form-check-input" type="radio" value="public" v-model="form.visibility" />
                      <span class="dq-radio-box">
                        <i class="ti ti-world"></i>
                        <span class="dq-radio-title">Public</span>
                      </span>
                    </label>

                    <label class="dq-radio">
                      <input class="form-check-input" type="radio" value="private" v-model="form.visibility" />
                      <span class="dq-radio-box">
                        <i class="ti ti-lock"></i>
                        <span class="dq-radio-title">Private</span>
                      </span>
                    </label>

                    <label class="dq-radio">
                      <input class="form-check-input" type="radio" value="restricted" v-model="form.visibility" />
                      <span class="dq-radio-box">
                        <i class="ti ti-users"></i>
                        <span class="dq-radio-title">Select People</span>
                      </span>
                    </label>
                  </div>

                  <div v-if="form.visibility === 'restricted'" class="dq-restrict mt-3">
                    <div class="dq-restrict-head">
                      <div class="dq-restrict-title">
                        <i class="ti ti-user-plus"></i> Choose people
                      </div>
                      <div class="dq-restrict-sub">
                        Select one or more users who can view this lead.
                      </div>
                    </div>

                    <!-- Selected chips -->
                    <div v-if="restrictedSelected.length" class="dq-selected mt-2">
                      <span class="dq-mini">Selected:</span>
                      <span v-for="u in restrictedSelected" :key="'sel-' + u.id" class="dq-chip">
                        <i class="ti ti-user"></i>
                        {{ u.label }}
                        <i class="ti ti-x ms-1" role="button" @click="removeRestricted(u.id)"></i>
                      </span>
                    </div>

                    <!-- Dropdown -->
                    <div class="dropdown w-100 mt-2" data-bs-auto-close="outside" data-bs-display="static">
                      <button
                        class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center"
                        type="button"
                        data-bs-toggle="dropdown"
                        @click="openRestrictedDropdown"
                      >
                        <span class="text-truncate">Add people…</span>
                        <i class="ti ti-chevron-down ms-2"></i>
                      </button>

                      <div class="dropdown-menu p-2 w-100 shadow">
                        <input
                          v-model="restrictedQuery"
                          type="text"
                          class="form-control mb-2"
                          placeholder="Search users…"
                          autocomplete="off"
                        />

                        <div class="search-list">
                          <div v-if="restrictedLoading" class="text-center py-2 small text-muted">
                            Loading…
                          </div>

                          <button
                            v-for="opt in restrictedOptions"
                            :key="'rest-' + opt.id"
                            type="button"
                            class="dropdown-item d-flex justify-content-between align-items-center"
                            @click="toggleRestricted(opt)"
                          >
                            <span class="text-truncate">{{ opt.label }}</span>
                            <i class="ti" :class="form.user_ids.includes(opt.id) ? 'ti-check' : 'ti-user-plus'"></i>
                          </button>

                          <div v-if="!restrictedLoading && !restrictedOptions.length" class="text-center py-2 small text-muted">
                            No results
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- Footer (sticky) -->
          <div class="modal-footer dq-modal-footer">
            <button
              type="button"
              class="btn btn-light dq-btn dq-btn-muted"
              data-bs-dismiss="modal"
              :disabled="leadStore.loading"
            >
              Cancel
            </button>

            <button
              type="submit"
              class="btn btn-primary dq-btn dq-btn-primary"
              :disabled="leadStore.loading"
            >
              <span v-if="leadStore.loading" class="spinner-border spinner-border-sm me-2"></span>
              {{ isEdit ? "Save Changes" : "Add Lead" }}
              <i class="ti ti-arrow-right ms-2"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Delete Modal (Deals-style) -->
  <div class="modal fade dq-leads-modal" id="delete_leads" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-sm dq-del-dialog">
      <div class="modal-content dq-modal-content">
        <div class="modal-header dq-modal-header dq-danger-head">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-red">
              <i class="ti ti-trash"></i>
            </div>
            <div>
              <h5 class="modal-title dq-title mb-0">Confirm Delete</h5>
              <div class="dq-subtitle">This action cannot be undone.</div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <div class="modal-body dq-modal-body">
          <div class="dq-danger">
            <i class="ti ti-alert-octagon"></i>
            <div>
              <div class="dq-danger-title">Delete this lead record?</div>
              <div class="dq-danger-sub">
                Reports and pipeline metrics may change after deletion.
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer dq-modal-footer">
          <button
            type="button"
            class="btn btn-light dq-btn dq-btn-muted"
            data-bs-dismiss="modal"
            :disabled="leadStore.loading"
          >
            Cancel
          </button>

          <button
            type="button"
            class="btn btn-danger dq-btn dq-btn-danger"
            :disabled="leadStore.loading"
            @click="confirmDelete"
          >
            <span v-if="leadStore.loading" class="spinner-border spinner-border-sm me-2"></span>
            Delete
            <i class="ti ti-trash ms-2"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import Modal from "bootstrap/js/dist/modal";
import { useLeadStore } from "@/stores/leadStore";
import { usePipelineStore } from "@/stores/pipelineStore";
import { useUserStore } from "@/stores/userStore";
import { toast } from "@/utils/toast";

const props = defineProps({ editItem: { type: Object, default: null } });
const emit = defineEmits(["saved"]);

const leadStore = useLeadStore();
const pipeStore = usePipelineStore();
const userStore = useUserStore();

const keyForce = ref(0);
const isEdit = computed(() => !!props.editItem?.id);

const form = ref(blankForm());

function blankForm() {
  return {
    id: null,
    name: "",
    party_type: "Organization",
    pipeline_id: null,
    stage_id: null,
    owner_id: null,
    company_name: "",
    amount: 0,
    currency: "KES",
    phone: "",
    phone_label: "",
    email: "",
    email_label: "",
    source: "",
    industry: "",
    description: "",
    tags: [],
    visibility: "public",
    user_ids: [],
  };
}

function reset() {
  Object.assign(form.value, blankForm());
  keyForce.value++;
}

const pipelines = computed(() => pipeStore.items || []);

const selectedPipeline = computed(() => {
  if (!form.value.pipeline_id) return null;
  return (
    pipelines.value.find((p) => Number(p.id) === Number(form.value.pipeline_id)) ||
    null
  );
});

const stageOptions = computed(() => selectedPipeline.value?.stages || []);

const users = computed(() => {
  const raw = Array.isArray(userStore.users)
    ? userStore.users
    : Array.isArray(userStore.users?.data)
    ? userStore.users.data
    : [];
  return raw;
});

function nameById(id) {
  const u = users.value.find((x) => Number(x.id) === Number(id));
  return u
    ? u.first_name
      ? `${u.first_name} ${u.last_name || ""}`.trim()
      : u.email
    : `User ${id}`;
}

function toNumOrNull(v) {
  return v === "" || v === null || v === undefined ? null : Number(v);
}
function toNumArray(a) {
  return Array.isArray(a)
    ? a.map((n) => Number(n)).filter((n) => Number.isFinite(n))
    : [];
}

/* -------------------------
   Searchable dropdowns (Pipeline / Stage / Owner)
------------------------- */

const pipelineQuery = ref("");
const stageQuery = ref("");
const ownerQuery = ref("");

const pipelineLoading = ref(false);
const stageLoading = ref(false);
const ownerLoading = ref(false);

const pipelineOptions = computed(() => {
  const q = pipelineQuery.value.trim().toLowerCase();
  const list = (pipelines.value || []).map((p) => ({
    id: Number(p.id),
    label: p.name,
  }));
  return q ? list.filter((x) => x.label.toLowerCase().includes(q)) : list;
});

const stageDropdownOptions = computed(() => {
  const q = stageQuery.value.trim().toLowerCase();
  const list = (stageOptions.value || []).map((s) => ({
    id: Number(s.id),
    label: s.name,
  }));
  return q ? list.filter((x) => x.label.toLowerCase().includes(q)) : list;
});

const ownerOptions = computed(() => {
  const q = ownerQuery.value.trim().toLowerCase();
  const list = (users.value || []).map((u) => ({
    id: Number(u.id),
    label: u.first_name
      ? `${u.first_name} ${u.last_name || ""}`.trim()
      : u.email,
  }));
  return q ? list.filter((x) => x.label.toLowerCase().includes(q)) : list;
});

function getPipelineLabel(id) {
  const p = (pipelines.value || []).find((x) => Number(x.id) === Number(id));
  return p?.name || `Pipeline ${id}`;
}
function getStageLabel(id) {
  const s = (stageOptions.value || []).find((x) => Number(x.id) === Number(id));
  return s?.name || `Stage ${id}`;
}
function getOwnerLabel(id) {
  return nameById(id);
}

async function openPipelineDropdown() {
  pipelineLoading.value = true;
  try {
    if (!pipeStore.items?.length) await pipeStore.ensureAll({ per_page: 200 });
  } finally {
    pipelineLoading.value = false;
  }
}
async function openStageDropdown() {
  stageLoading.value = true;
  try {
    // stages are embedded in selectedPipeline
  } finally {
    stageLoading.value = false;
  }
}
async function openOwnerDropdown() {
  ownerLoading.value = true;
  try {
    if (!userStore.users?.length) await userStore.ensureUsers({ per_page: 200 });
  } finally {
    ownerLoading.value = false;
  }
}

function onPipelineInput() {}
function onStageInput() {}
function onOwnerInput() {}

function selectPipeline(opt) {
  form.value.pipeline_id = Number(opt.id);

  // reset stage if invalid
  if (
    !stageOptions.value.find((s) => Number(s.id) === Number(form.value.stage_id))
  ) {
    form.value.stage_id = stageOptions.value[0]?.id ?? null;
  }
}
function selectStage(opt) {
  form.value.stage_id = Number(opt.id);
}
function selectOwner(opt) {
  form.value.owner_id = Number(opt.id);
}

function clearPipeline() {
  form.value.pipeline_id = null;
  form.value.stage_id = null;
  pipelineQuery.value = "";
  stageQuery.value = "";
}

watch(
  () => form.value.pipeline_id,
  () => {
    if (!stageOptions.value.find((s) => Number(s.id) === Number(form.value.stage_id))) {
      form.value.stage_id = stageOptions.value[0]?.id
        ? Number(stageOptions.value[0].id)
        : null;
    }
  }
);

/* -------------------------
   Restricted users picker (Deals-style)
------------------------- */

const restrictedQuery = ref("");
const restrictedLoading = ref(false);

const restrictedOptions = computed(() => {
  const q = restrictedQuery.value.trim().toLowerCase();
  return users.value
    .map((u) => ({
      id: Number(u.id),
      label: u.first_name
        ? `${u.first_name} ${u.last_name || ""}`.trim()
        : u.email,
    }))
    .filter((x) => (q ? x.label.toLowerCase().includes(q) : true));
});

const restrictedSelected = computed(() =>
  restrictedOptions.value.filter((x) => form.value.user_ids.includes(x.id))
);

async function openRestrictedDropdown() {
  restrictedLoading.value = true;
  try {
    if (!userStore.users?.length) await userStore.ensureUsers({ per_page: 200 });
  } finally {
    restrictedLoading.value = false;
  }
}

function toggleRestricted(opt) {
  const idx = form.value.user_ids.indexOf(opt.id);
  if (idx === -1) form.value.user_ids.push(opt.id);
  else form.value.user_ids.splice(idx, 1);
}

function removeRestricted(id) {
  form.value.user_ids = form.value.user_ids.filter(
    (x) => Number(x) !== Number(id)
  );
}

/* -------------------------
   Hydrate / Save / Delete
------------------------- */

function hydrateFromEditItem(val) {
  if (!val) {
    reset();
    return;
  }

  form.value.id = val.id ?? null;
  form.value.name = val.name ?? "";
  form.value.party_type = val.party_type ?? "Organization";

  form.value.pipeline_id = toNumOrNull(val.pipeline_id);
  form.value.stage_id = toNumOrNull(val.stage_id);
  form.value.owner_id = toNumOrNull(val.owner_id);

  form.value.company_name = val.company_name ?? "";
  form.value.amount = Number(val.amount ?? 0);
  form.value.currency = val.currency ?? "KES";
  form.value.phone = val.phone ?? "";
  form.value.phone_label = val.phone_label ?? "";
  form.value.email = val.email ?? "";
  form.value.email_label = val.email_label ?? "";
  form.value.source = val.source ?? "";
  form.value.industry = val.industry ?? "";
  form.value.description = val.description ?? "";

  form.value.tags = Array.isArray(val.tags)
    ? [...val.tags]
    : (val.tags ?? "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);

  form.value.visibility = val.visibility ?? "public";

  const idsFromArray = toNumArray(val.user_ids);
  const idsFromObjects = Array.isArray(val.users)
    ? toNumArray(val.users.map((u) => u.id))
    : [];

  form.value.user_ids = [...new Set([...idsFromArray, ...idsFromObjects])];

  if (form.value.user_ids.length && form.value.visibility !== "restricted") {
    form.value.visibility = "restricted";
  }

  if (!stageOptions.value.find((s) => Number(s.id) === Number(form.value.stage_id))) {
    form.value.stage_id = stageOptions.value[0]?.id
      ? Number(stageOptions.value[0].id)
      : null;
  }

  keyForce.value++;
}

watch(
  () => props.editItem,
  async (val) => {
    if (!pipeStore.items?.length) await pipeStore.ensureAll({ per_page: 200 });
    if (!userStore.users?.length) await userStore.ensureUsers({ per_page: 200 });
    hydrateFromEditItem(val);
  },
  { immediate: true }
);

function hide() {
  const el = document.getElementById("add_leads");
  const inst = el
    ? Modal.getInstance(el) || Modal.getOrCreateInstance(el)
    : null;
  inst?.hide();
}

function toPayload(f) {
  return {
    name: f.name?.trim(),
    party_type: f.party_type || "Organization",
    pipeline_id: f.pipeline_id || null,
    stage_id: f.stage_id || null,
    owner_id: f.owner_id || null,
    company_name: f.company_name?.trim() || null,
    amount: Number.isFinite(f.amount) ? f.amount : 0,
    currency: f.currency || "KES",
    phone: f.phone?.trim() || null,
    phone_label: f.phone_label || null,
    email: f.email?.trim() || null,
    email_label: f.email_label || null,
    source: f.source?.trim() || null,
    industry: f.industry?.trim() || null,
    description: f.description?.trim() || null,
    tags: Array.isArray(f.tags) ? f.tags : [],
    visibility: f.visibility || "public",
    user_ids: f.visibility === "restricted" ? [...f.user_ids] : [],
  };
}

async function submit() {
  if (!form.value.name?.trim()) return toast("Lead name is required", "error");
  if (form.value.visibility === "restricted" && !form.value.user_ids.length) {
    return toast(
      "Select at least one user or choose a different visibility",
      "error"
    );
  }

  const payload = toPayload(form.value);
  try {
    if (isEdit.value && form.value.id) await leadStore.update(form.value.id, payload);
    else await leadStore.create(payload);

    hide();
    emit("saved");
  } catch (e) {
    toast(e?.response?.data?.message || "Failed to save lead", "error");
  }
}

function hideDelete() {
  const el = document.getElementById("delete_leads");
  const inst = el
    ? Modal.getInstance(el) || Modal.getOrCreateInstance(el)
    : null;
  inst?.hide();
}

async function confirmDelete() {
  try {
    if (!props.editItem?.id) return;
    await leadStore.remove(props.editItem.id);
    hideDelete();
    emit("saved");
  } catch (e) {
    console.error(e);
  }
}

onMounted(async () => {
  if (!pipeStore.items?.length) await pipeStore.ensureAll({ per_page: 200 });
  if (!userStore.users?.length) await userStore.ensureUsers({ per_page: 200 });

  const el = document.getElementById("add_leads");
  el?.addEventListener("show.bs.modal", () => {
    if (isEdit.value) hydrateFromEditItem(props.editItem);
    else reset();
  });
  el?.addEventListener("hidden.bs.modal", reset);
});
</script>

<style scoped>
/* Wider + premium */
.dq-leads-dialog {
  max-width: 1180px;
}
.dq-del-dialog {
  max-width: 540px;
}
@media (max-width: 992px) {
  .dq-leads-dialog,
  .dq-del-dialog {
    max-width: 96%;
  }
}

/* Modal shell */
.dq-modal-content {
  border-radius: 22px;
  border: none;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08),
    0 40px 90px rgba(15, 23, 42, 0.14);
}

.dq-modal-header {
  padding: 18px 22px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, rgba(99, 102, 241, 0.14), #fff);
}
.dq-danger-head {
  background: linear-gradient(180deg, rgba(239, 68, 68, 0.12), #fff);
}

.dq-modal-body {
  padding: 18px 22px;
  max-height: calc(100vh - 230px);
  overflow: auto;
}

.dq-modal-footer {
  padding: 14px 22px;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 2;
}

/* Header */
.dq-titlewrap {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dq-title {
  font-weight: 950;
  letter-spacing: -0.35px;
}
.dq-subtitle {
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.6);
}
.dq-head-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dq-close {
  opacity: 0.9;
}
.dq-close:hover {
  opacity: 1;
}

/* Hero */
.dq-hero {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.dq-hero-indigo {
  background: rgba(99, 102, 241, 0.16);
  color: rgb(79, 70, 229);
}
.dq-hero-red {
  background: rgba(239, 68, 68, 0.14);
  color: rgb(220, 38, 38);
}

/* Header pill */
.dq-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 999px;
  padding: 8px 12px;
  background: rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(15, 23, 42, 0.06);
  font-weight: 900;
}
.dq-pill-label {
  font-size: 0.78rem;
  color: rgba(15, 23, 42, 0.6);
}
.dq-pill-value {
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.9);
}

/* Cards */
.dq-card {
  border-radius: 18px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
  padding: 14px;
}
.dq-card-head {
  padding: 2px 2px 10px;
}
.dq-card-title {
  font-weight: 950;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.dq-card-sub {
  margin-top: 6px;
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.6);
}

/* Inputs */
.dq-label {
  font-size: 0.82rem;
  font-weight: 900;
}
.dq-input {
  border-radius: 14px;
  padding: 10px 12px;
}
.dq-input:focus {
  border-color: rgba(99, 102, 241, 0.55);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.14);
}
.dq-textarea {
  resize: vertical;
}
.dq-help {
  margin-top: 6px;
  font-size: 0.8rem;
  color: rgba(15, 23, 42, 0.55);
}

/* Input group */
.dq-inputgroup {
  display: flex;
  align-items: center;
  border-radius: 14px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  overflow: hidden;
  background: #fff;
}
.dq-addon {
  width: 44px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.04);
  border-right: 1px solid rgba(15, 23, 42, 0.08);
  color: rgba(15, 23, 42, 0.7);
}
.dq-inputgroup-input {
  border: none;
  box-shadow: none !important;
  border-radius: 0;
}

/* Tags */
.dq-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.dq-tagcheck {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: rgba(15, 23, 42, 0.02);
  font-weight: 900;
  font-size: 0.82rem;
  cursor: pointer;
  user-select: none;
}
.dq-tagcheck input {
  margin-top: 0;
}
.dq-selected-tags {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.dq-mini {
  font-size: 0.78rem;
  color: rgba(15, 23, 42, 0.55);
  font-weight: 900;
}

/* Chips */
.dq-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 999px;
  padding: 8px 12px;
  background: rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(15, 23, 42, 0.06);
  font-weight: 900;
  font-size: 0.82rem;
}
.dq-chip i.ti-x {
  cursor: pointer;
  opacity: 0.7;
}
.dq-chip i.ti-x:hover {
  opacity: 1;
}

/* Visibility cards */
.dq-visibility {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 12px;
}
@media (max-width: 992px) {
  .dq-visibility {
    grid-template-columns: 1fr;
  }
}
.dq-radio {
  cursor: pointer;
  user-select: none;
  display: block;
}
.dq-radio input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.dq-radio-box {
  display: grid;
  grid-template-columns: 28px 1fr;
  gap: 10px;
  align-items: start;
  padding: 12px;
  border-radius: 18px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: rgba(15, 23, 42, 0.02);
  transition: all 0.15s ease;
}
.dq-radio-box i {
  margin-top: 2px;
  font-size: 18px;
  color: rgba(15, 23, 42, 0.7);
}
.dq-radio-title {
  font-weight: 950;
}
.dq-radio input:checked + .dq-radio-box {
  border-color: rgba(99, 102, 241, 0.35);
  background: rgba(99, 102, 241, 0.08);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}
.dq-radio input:checked + .dq-radio-box i {
  color: rgb(79, 70, 229);
}

/* Restricted box */
.dq-restrict {
  border-radius: 18px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: rgba(15, 23, 42, 0.02);
  padding: 12px;
}
.dq-restrict-title {
  font-weight: 950;
  display: inline-flex;
  gap: 8px;
  align-items: center;
}
.dq-restrict-sub {
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.6);
}

/* Dropdown list */
.search-list {
  max-height: 260px;
  overflow: auto;
  border-radius: 12px;
}
.dropdown-menu.w-100 {
  min-width: 100% !important;
}
.dropdown-item {
  border-radius: 10px;
}
.dropdown-item:active {
  background: rgba(99, 102, 241, 0.12);
}

/* Buttons */
.dq-btn {
  border-radius: 12px;
  padding: 10px 16px;
  font-weight: 900;
}
.dq-btn-muted {
  background: rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(15, 23, 42, 0.06);
}
.dq-btn-primary {
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.1);
}
.dq-btn-danger {
  box-shadow: 0 12px 24px rgba(239, 68, 68, 0.12);
}

/* Delete warning */
.dq-danger {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px 14px;
  border-radius: 18px;
  border: 1px solid rgba(239, 68, 68, 0.14);
  background: rgba(239, 68, 68, 0.08);
}
.dq-danger i {
  font-size: 18px;
  color: rgb(220, 38, 38);
  margin-top: 2px;
}
.dq-danger-title {
  font-weight: 950;
}
.dq-danger-sub {
  margin-top: 6px;
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.7);
}

/* Type toggle pills */
.dq-toggle {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.dq-pillbtn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: rgba(15, 23, 42, 0.02);
  font-weight: 900;
  cursor: pointer;
  user-select: none;
}
.dq-pillbtn input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.dq-pillbtn.active {
  border-color: rgba(99, 102, 241, 0.35);
  background: rgba(99, 102, 241, 0.08);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}
</style>
